import { useCustom } from '@refinedev/core';

type AppInfo = {
  version: string;
};

export const useAppInfo = () => {
  const { data, isLoading, isError, error, refetch } = useCustom<AppInfo>({
    url: 'info',
    method: 'get',
  });

  return {
    info: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
